import type ts from 'typescript';

import type { Evaluator } from '../types';

const evaluateParenthesizedExpression: Evaluator<ts.ParenthesizedExpression> = ({ node, variables, log, evaluators }) =>
  evaluators.expression({
    evaluators,
    log,
    node: node.expression,
    variables,
  });

export default evaluateParenthesizedExpression;
